import { Directive, ElementRef, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Guid, Utility } from 'src/app/core/common';

@Directive({
  selector: '[copy]',
  host: { '(click)': 'clipboard()' }
})
export class CopyDirective {
  id = Guid.newGuid();
  empty: boolean;
  constructor(private element: ElementRef<HTMLElement>, private toastr: ToastrService) { }

  @Input() message: string = 'کپی شد';
  @Input() copy: string;
  clipboard() {
    if (this.copy) {
      var copied = Utility.setClipboard(this.copy);
      this.toastr.info(this.message);
      if (copied) return true;
    }

    if (!navigator.userAgent.match(/ipad|ipod|iphone/i) && (<HTMLInputElement>this.element.nativeElement).select) {
      (<HTMLInputElement>this.element.nativeElement).select();
    } else {
      const editable = this.element.nativeElement.contentEditable;
      this.element.nativeElement.contentEditable = 'true';
      const range = document.createRange();
      range.selectNodeContents(this.element.nativeElement);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      if ((<HTMLInputElement>this.element.nativeElement).setSelectionRange) {
        (<HTMLInputElement>this.element.nativeElement).setSelectionRange(0, 999999);
      }
      this.element.nativeElement.contentEditable = editable;
    }

    try {
      if (document.execCommand('copy')) {
        this.toastr.info(this.message);
        return true;
      }
    } catch (err) { }
    return false;
  }
  
  ngOnInit() {
    const elem = <HTMLElement>this.element.nativeElement;
    elem.insertAdjacentHTML('afterbegin', '<span id="copy-' + this.id + '" class="icons copy" title="برای کپی کردن کلیک کنید"></span>');
  }
  ngOnDestroy() {
    const elem = document.getElementById('copy-' + this.id);
    if (elem) { elem.remove(); }
  }
}
